import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateStyleBody, StylesUploadUrlData } from '../types';

export function useCreateStyle() {
  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<StylesUploadUrlData>('/styles/upload-url', {
    queryKey: ['styleUploadUrl'],
    initialData: null,
  });

  const createStyleMutation = useApiMutation<CreateStyleBody>(
    '/styles',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    refetchUploadUrl,
    createStyleMutation,
  } as const;
}
